import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import { setEmpFetchter } from "../Filter/actions";
import {
  addEmployeeFailure,
  addEmployeeSuccess,
  deleteDocFailure,
  deleteDocSuccess,
  deleteEmployeeFailure,
  //
  deleteEmployeeSuccess,
  editEmployeeFailure,
  //
  editEmployeeSuccess,
  //
  fetchEmployee as fetchEmployeeAction,
  fetchEmployeeFailure,
  fetchEmployeeSuccess,
  getBirthdaysFailure,
  getBirthdaysSuccess,
  getEmpHistoryFailure,
  getEmpHistorySuccess,
  getEmptyClocksFailure,
  getEmptyClocksSuccess,
  getEmptyShiftsFailure,
  getEmptyShiftsSuccess,
  getExpiringDocsFailure,
  getExpiringDocsSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  importCSVFailure,
  importCSVSuccess,
  saveDocsFailure,
  //
  saveDocsSuccess,
  saveInfoFailure,
  //
  saveInfoSuccess,
  savePayrollFailure,
  //
  savePayrollSuccess,
  savePinFailure,
  savePinSuccess,
  saveProfileFailure,
  //
  saveProfileSuccess,
  saveScheduleFailure,
  //
  saveScheduleSuccess,
  searchEmployeeFailure,
  //
  searchEmployeeSuccess,
  searchManagerFailure,
  searchManagerSuccess,
  searchRotaEmployeeFailure,
  searchRotaEmployeeSuccess,
  //
  sendInviteFailure,
  sendInviteSuccess,
  sendMailFailure,
  sendMailSuccess,
  uploadCSVFailure,
  uploadCSVSuccess,
  getMatrixFailure,
  getMatrixSuccess,
  setMatrixSteps,
  getMatrixStatsSuccess,
  getMatrixStatsFailure,
  deleteDocVersionFailure,
  deleteDocVersionSuccess,
  getEmpIndicatorsFailure,
  getEmpIndicatorsSuccess,
} from "./actions";
import {
  ADD_EMPLOYEE,
  DELETE_DOC,
  DELETE_EMPLOYEE,
  EDIT_EMPLOYEE,
  FETCH_EMPLOYEE,
  GET_VIEW_DATA,
  SAVE_DOCS,
  SAVE_INFO,
  SAVE_PAYROLL,
  SAVE_PIN,
  SAVE_PROFILE,
  SAVE_SCHEDULE,
  SEARCH_EMPLOYEE,
  SEARCH_MANAGER,
  SEND_INVITE,
  SEND_MAIL,
  UPLOAD_CSV,
  IMPORT_CSV,
  GET_EMP_HISTORY,
  GET_BIRTHDAYS,
  GET_EXPIRING_DOCS,
  GET_EMPTY_SHIFTS,
  GET_EMPTY_CLOCKS,
  SEARCH_ROTA_EMPLOYEE,
  GET_MATRIX,
  GET_MATRIX_STATS,
  DELETE_DOC_VERSION,
  GET_EMP_INDICATORS,
} from "./constants";
import { setOnboardingData } from "../Onboarding/actions";
import { getBasicInfo, getDocuments } from "../EmployeeEdit/actions";

export function* fetchEmployeeSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const employeeList = yield select(
    (state) => state?.EmployeeReducer?.employeeList,
  );
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee?${query}`,
      payload,
    );
    if (payload?.is_lazy) {
      let tempList = JSON.parse(JSON.stringify(data));
      if (employeeList?.data?.length > 0) {
        tempList.data = [...employeeList.data, ...tempList.data];
      }
      yield put(fetchEmployeeSuccess(tempList));
    } else {
      yield put(fetchEmployeeSuccess(data));
    }
    yield put(setEmpFetchter(true));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(setEmpFetchter(true));
    yield put(fetchEmployeeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching employee!"));
  }
}

export function* getViewDataSaga({ payload, shouldSetOnboardingData }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).get, `/api/employee/${payload}`);
    yield put(getViewDataSuccess(data));
    if (shouldSetOnboardingData) yield put(setOnboardingData(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addEmployeeSaga({ payload, history }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { formData, isUser } = payload;
  try {
    const data = yield call(api(token).post, `/api/employee/add`, formData);
    if (data) {
      yield put(successAlert("Employee added successfully!"));
      yield put(addEmployeeSuccess());
      history.push(isUser ? `/d/users` : `/d/hr/employee`);
    }
  } catch (e) {
    yield put(addEmployeeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editEmployeeSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      payload?.isUser
        ? `/api/employee/update/${payload.id}`
        : `/api/employee/edit/${payload.id}`,
      payload,
    );
    if (data) {
      yield put(
        successAlert(
          `${payload?.isUser ? `User` : `Employee`} updated successfully!`,
        ),
      );
      yield put(editEmployeeSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editEmployeeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteEmployeeSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const user = yield select((state) => state?.AuthReducer?.user);

  try {
    const data = yield call(api(token).delete, `/api/employee/${payload}`);
    if (data) {
      yield put(successAlert("Employee deleted successfully!"));
      yield put(deleteEmployeeSuccess());
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(deleteEmployeeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}
export function* searchEmployeeSaga({
  payload = { cancelToken: null },
  onSuccess,
  values,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/search-employee?${query}`,
    );
    yield put(searchEmployeeSuccess(data));
    typeof onSuccess === "function" && onSuccess(data, values);
  } catch (e) {
    yield put(searchEmployeeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching employee!"));
  }
}
export function* searchManagerSaga({
  payload = { cancelToken: null },
  onSuccess,
  values,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/assign-manager-list?${query}`,
    );
    yield put(searchManagerSuccess(data));
    typeof onSuccess === "function" && onSuccess(data, values);
  } catch (e) {
    yield put(searchManagerFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching employee!"));
  }
}
export function* saveInfoSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/employee-info/add`, payload);
    if (data) {
      yield put(successAlert("Personal information saved successfully!"));
      yield put(saveInfoSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(saveInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}
export function* saveDocsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const apiConfig = {
    add: `/api/employee-document/add`,
    common_edit: `/api/employee-document/edit`,
    other_edit: `/api/hr/onboarding/document-update`,
  };

  try {
    const data = yield call(
      api(token).post,
      apiConfig[payload.type],
      payload.data,
    );
    if (data) {
      yield put(successAlert("Document updated successfully!"));
      yield put(saveDocsSuccess());
      yield put(getDocuments(payload.employee_id));
    }
  } catch (e) {
    yield put(saveDocsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* saveScheduleSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/employee-schedule/add`,
      payload.data,
    );
    if (data) {
      yield put(successAlert("Schedule saved successfully!"));
      yield put(saveScheduleSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(saveScheduleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}
export function* sendInviteSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).get, `/api/resend-invite/${payload}`);
    if (data) {
      yield put(successAlert("Invite sent successfully!"));
      yield put(sendInviteSuccess());
      yield put(getViewDataAction(payload));
    }
  } catch (e) {
    yield put(sendInviteFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}
export function* sendProfileSaga({ payload, onSave }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/save-profile/${payload.id}`,
      payload.data,
    );
    if (data) {
      yield put(successAlert("Profile image uploaded successfully!"));
      yield put(saveProfileSuccess());
      yield put(getBasicInfo(payload.id));
      typeof onSave === "function" && onSave();
    }
  } catch (e) {
    yield put(saveProfileFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* sendPayrollSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/employee-payroll/add`,
      payload,
    );
    if (data) {
      yield put(successAlert("Payroll info updated successfully!"));
      yield put(savePayrollSuccess());
      yield put(getViewDataAction(payload.employee_id));
    }
  } catch (e) {
    yield put(savePayrollFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteDocSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, type, employee_id } = payload;
  try {
    const data = yield call(
      api(token).delete,
      `/api/employee-document/${id}/${type}/${employee_id}`,
    );
    if (data) {
      yield put(successAlert("Document deleted successfully!"));
      yield put(deleteDocSuccess());
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(deleteDocFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* savePinSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/set-reset/clockin-pin`,
      payload,
    );
    if (data) {
      yield put(successAlert("Pin set successfully!"));
      yield put(savePinSuccess());
      yield put(getViewDataAction(payload.employee_id));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(savePinFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* sendMailSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).get,
      `/api/send-clock-pin-mail/${payload.employee_id}`,
    );
    if (data) {
      yield put(successAlert("Pin will be sent to the employee's email!"));
      yield put(sendMailSuccess());
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(sendMailFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* uploadCsvSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee-csv-upload`,
      payload?.formData,
    );
    if (data.length == 0) {
      yield put(successAlert("CSV uploaded successfully"));
      yield put(uploadCSVSuccess([]));
    } else {
      yield put(errorAlert("There is an error while adding data!"));
      yield put(uploadCSVSuccess({ error: data }));
    }
    typeof onSuccess === "function" && onSuccess();
  } catch (e) {
    yield put(uploadCSVFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* importCSVSaga({ payload, onImport }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee-import`,
      payload,
    );
    yield put(successAlert("CSV uploaded successfully"));
    yield put(importCSVSuccess([]));
    typeof onImport === "function" && onImport(false);
  } catch (e) {
    let { data } = e?.response?.data;
    yield put(importCSVFailure(data));
    typeof onImport === "function" && onImport(true);
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getEmpHistorySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee-History/${payload.id}`,
    );
    if (data) {
      yield put(getEmpHistorySuccess(data));
    }
  } catch (e) {
    yield put(getEmpHistoryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getBirthdaysSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employees/birthdays/${payload.location_id}`,
    );
    if (data) {
      yield put(getBirthdaysSuccess(data));
    }
  } catch (e) {
    yield put(getBirthdaysFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getExpiringDocsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/documents-expiring-soon/${payload.location_id}`,
    );
    if (data) {
      yield put(getExpiringDocsSuccess(data));
    }
  } catch (e) {
    yield put(getExpiringDocsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getEmptyShiftsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employees-not-clocked-in/${payload.location_id}`,
    );
    if (data) {
      yield put(getEmptyShiftsSuccess(data));
    }
  } catch (e) {
    yield put(getEmptyShiftsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getEmptyClocksSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employees-not-clocked-out/${payload.location_id}`,
    );
    if (data) {
      yield put(getEmptyClocksSuccess(data));
    }
  } catch (e) {
    yield put(getEmptyClocksFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* searchRotaEmployeeSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.params ? QueryString.stringify(payload?.params) : "";

  try {
    const { data } = yield call(
      api(token).get,
      `/api/search-rota-employee/${payload?.location_id}?${query}`,
    );
    yield put(searchRotaEmployeeSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(searchRotaEmployeeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching employee!"));
  }
}

export function* getMatrixSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { matrixList } = yield select((state) => state?.EmployeeReducer);
  const { filters } = payload;
  let query = filters ? QueryString.stringify(filters) : "";
  let updatedResponse = { ...matrixList };
  try {
    const { data } = yield call(
      api(token).get,
      `/api/hr/onboarding-employee?${query}`,
    );
    if (filters?.page <= 1) {
      updatedResponse = data;
    } else {
      updatedResponse = {
        ...data,
        data: updatedResponse.data.concat(data?.data),
      };
    }
    if (updatedResponse?.data?.length > 0) {
      yield put(setMatrixSteps(updatedResponse.data[0].step_list ?? []));
    }
    yield put(getMatrixSuccess(updatedResponse));
  } catch (e) {
    yield put(getMatrixFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getMatrixStatsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { location_id, filters } = payload;
  let query = filters ? QueryString.stringify(filters) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/hr/onboarding/step-percentage/${location_id}?${query}`,
    );
    yield put(getMatrixStatsSuccess(data));
  } catch (e) {
    yield put(getMatrixStatsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteDocVersionSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, type } = payload;

  try {
    const data = yield call(
      api(token).delete,
      `/api/employee-doc-version-delete/${id}/${type}`,
    );
    if (data) {
      yield put(successAlert("Document version deleted successfully!"));
      yield put(deleteDocVersionSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    typeof onDelete === "function" && onDelete();
    yield put(deleteDocVersionFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getEmpIndicatorsSaga() {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).get, `/api/onboarding-indicator`);
    yield put(getEmpIndicatorsSuccess(data));
  } catch (e) {
    yield put(getEmpIndicatorsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchEmployeeFlow() {
  yield takeEvery(FETCH_EMPLOYEE, fetchEmployeeSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addEmployeeFlow() {
  yield takeEvery(ADD_EMPLOYEE, addEmployeeSaga);
}
export function* editEmployeeFlow() {
  yield takeEvery(EDIT_EMPLOYEE, editEmployeeSaga);
}
export function* deleteEmployeeFlow() {
  yield takeEvery(DELETE_EMPLOYEE, deleteEmployeeSaga);
}
export function* searchEmployeeFlow() {
  yield takeEvery(SEARCH_EMPLOYEE, searchEmployeeSaga);
}
export function* saveInfoFlow() {
  yield takeEvery(SAVE_INFO, saveInfoSaga);
}
export function* saveDocsFlow() {
  yield takeEvery(SAVE_DOCS, saveDocsSaga);
}
export function* saveScheduleFlow() {
  yield takeEvery(SAVE_SCHEDULE, saveScheduleSaga);
}
export function* sendInviteFlow() {
  yield takeEvery(SEND_INVITE, sendInviteSaga);
}
export function* sendProfileFlow() {
  yield takeEvery(SAVE_PROFILE, sendProfileSaga);
}
export function* sendPayrollFlow() {
  yield takeEvery(SAVE_PAYROLL, sendPayrollSaga);
}
export function* deleteDocFlow() {
  yield takeEvery(DELETE_DOC, deleteDocSaga);
}
export function* savePinFlow() {
  yield takeEvery(SAVE_PIN, savePinSaga);
}
export function* sendMailFlow() {
  yield takeEvery(SEND_MAIL, sendMailSaga);
}
export function* uploadCsvFlow() {
  yield takeEvery(UPLOAD_CSV, uploadCsvSaga);
}
export function* searchManagerFlow() {
  yield takeEvery(SEARCH_MANAGER, searchManagerSaga);
}
export function* importCSVFlow() {
  yield takeEvery(IMPORT_CSV, importCSVSaga);
}
export function* getEmpHistoryFlow() {
  yield takeEvery(GET_EMP_HISTORY, getEmpHistorySaga);
}
export function* getBirthdaysFlow() {
  yield takeEvery(GET_BIRTHDAYS, getBirthdaysSaga);
}
export function* getExpiringDocsFlow() {
  yield takeEvery(GET_EXPIRING_DOCS, getExpiringDocsSaga);
}
export function* getEmptyShiftsFlow() {
  yield takeEvery(GET_EMPTY_SHIFTS, getEmptyShiftsSaga);
}
export function* getEmptyClocksFlow() {
  yield takeEvery(GET_EMPTY_CLOCKS, getEmptyClocksSaga);
}
export function* searchRotaEmployeeFlow() {
  yield takeEvery(SEARCH_ROTA_EMPLOYEE, searchRotaEmployeeSaga);
}
export function* getMatrixFlow() {
  yield takeEvery(GET_MATRIX, getMatrixSaga);
}
export function* getMatrixStatsFlow() {
  yield takeEvery(GET_MATRIX_STATS, getMatrixStatsSaga);
}
export function* deleteDocVersionFlow() {
  yield takeEvery(DELETE_DOC_VERSION, deleteDocVersionSaga);
}
export function* getEmpIndicatorsFlow() {
  yield takeEvery(GET_EMP_INDICATORS, getEmpIndicatorsSaga);
}

export default function* EmployeeSaga() {
  yield all([
    fetchEmployeeFlow(),
    addEmployeeFlow(),
    editEmployeeFlow(),
    deleteEmployeeFlow(),
    getViewDataFlow(),
    searchEmployeeFlow(),
    saveInfoFlow(),
    saveDocsFlow(),
    saveScheduleFlow(),
    sendInviteFlow(),
    sendProfileFlow(),
    sendPayrollFlow(),
    deleteDocFlow(),
    savePinFlow(),
    sendMailFlow(),
    uploadCsvFlow(),
    searchManagerFlow(),
    importCSVFlow(),
    getEmpHistoryFlow(),
    getBirthdaysFlow(),
    getExpiringDocsFlow(),
    getEmptyShiftsFlow(),
    getEmptyClocksFlow(),
    searchRotaEmployeeFlow(),
    getMatrixFlow(),
    getMatrixStatsFlow(),
    deleteDocVersionFlow(),
    getEmpIndicatorsFlow(),
  ]);
}
